"use strict";
import { useMedia } from "ui/src";
export function useIsMobile() {
  const media = useMedia();
  return media.md;
}
